"use strict";

(function () {
  'use strict';

  angular.module('app.components', ['directive.email-match', 'directive.password-strength', 'lr.card', 'main-nav', 'vertical-nav', 'trip-card', 'message-box', 'loading-overlay', 'lr.reserve.billing-summary', 'lr.reserve.payment-summary', 'lr.reserve.option', 'option-compact', 'options-modal', 'payment-modal', 'profile-widget', 'trip-compact', 'status-charms', 'connection-modal', 'footer-nav']);
})();